import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import PropTypes from 'prop-types';
import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { EPaymentType, EStatus } from "../../_shared/constants";
import { SimpleModalWrapper } from "../../_shared/utils/SimpleModalWrapper";
import { fetchSberBinding } from "../../api/requests/sber";
import { Closure } from "../../components";
import { PAY_BTN_STATUSES, SBER_POPUP_KEY } from "../../constants/payment";
import { deleteQueryParam } from "../PaymentForm/helpers";
import { getInlineLayoutFlag, getIsRedesign, getPaymentSum } from "../../store/common/selectors";
import { sberActions } from "../../store/features/sberpay/actions";
import { getSberPayContent, getSberPayFrom3DS, getSberPaySettings, getSberPaymentStatus, getShowSberResultPopup } from "../../store/features/sberpay/selectors";
import { findFirst } from "../../utils/arrays";
import { withOnScreenAnalytics } from "../../_shared/utils/withOnScreenAnalytics";
import { getOnScreenAnalyticsHandler } from "../../_shared/analytics/paymentGoalReached";
import { withAnalytics } from "./analytics/withAnalytics";
import { RequestStatus } from "./components/RequestStatus";
var EnhancedSuccessModal = compose(withOnScreenAnalytics(getOnScreenAnalyticsHandler(EPaymentType.SberPay), {
  shouldTriggerOnce: true,
  debounce: 100
}))(RequestStatus);
var ResultPopup = function ResultPopup(_ref) {
  var withModal = _ref.withModal,
    isError = _ref.isError,
    onConfirm = _ref.onConfirm,
    sberPay = _ref.sberPay,
    inlineLayout = _ref.inlineLayout,
    sum = _ref.sum;
  var dispatch = useDispatch();
  var content = useSelector(getSberPayContent);
  var Wrapper = withModal ? Closure : SimpleModalWrapper;
  var handleConfirmation = React.useCallback(function () {
    dispatch(sberActions.setPaymentStatus(PAY_BTN_STATUSES.initial));
    dispatch(sberActions.setUnBinded(false));
    deleteQueryParam(SBER_POPUP_KEY);
    onConfirm === null || onConfirm === void 0 || onConfirm(isError);
    dispatch(sberActions.setFrom3DS(false));
    if (sberPay.settings.isAuthenticated && inlineLayout) {
      var fetchBinding = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchSberBinding();
              case 2:
                res = _context.sent;
                if (res) {
                  dispatch(sberActions.setBinding(res));
                }
                return _context.abrupt("return", null);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function fetchBinding() {
          return _ref2.apply(this, arguments);
        };
      }();
      fetchBinding();
    }
  }, [onConfirm]);
  var Component = isError ? RequestStatus : EnhancedSuccessModal;
  return /*#__PURE__*/React.createElement(Wrapper, {
    onClose: handleConfirmation
  }, /*#__PURE__*/React.createElement(Component, _extends({
    onCloseModal: findFirst([isError && handleConfirmation]),
    onConfirm: handleConfirmation,
    sum: sum,
    withModal: withModal
  }, findFirst([isError && content.error, content.success]), {
    step: findFirst([isError && EStatus.Error, EStatus.Success])
  })));
};
ResultPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  isError: PropTypes.bool,
  withModal: PropTypes.bool,
  onConfirm: PropTypes.func
} : {};
export default compose(connect(function (state) {
  var _getSberPaymentStatus;
  return {
    isError: (_getSberPaymentStatus = getSberPaymentStatus(state)) === null || _getSberPaymentStatus === void 0 ? void 0 : _getSberPaymentStatus.toLowerCase().includes('error'),
    withModal: !getIsRedesign(state) && (getSberPayFrom3DS(state) || getInlineLayoutFlag(state)),
    inlineLayout: getInlineLayoutFlag(state),
    shouldRender: getShowSberResultPopup(state),
    sberPay: {
      settings: getSberPaySettings(state)
    },
    sum: getPaymentSum(state)
  };
}), withRenderFlag, withAnalytics)(ResultPopup);